export const userlist = [
  {
    path: '/userlist',
    label: '白名单列表',
    sort: '1-1',
    hidden: false,
    showMenus: true,
    component: () => import('@/views/user-center/user-management')
  },
  {
    path: '/userlist/detail',
    label: '白名单详情',
    sort: '1-1-1',
    hidden: true,
    showMenus: true,
    component: () => import('@/views/user-center/user-management-details'),
    meta: {
      guidePath: true,
      jumpPath: '/userlist'
    }
  }
]
